// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import meetingDelegateEntity from './entities/meeting-delegate.json';
import meetingDelegateMenu from '../pages/meeting-delegate/menu.json';
import meetingDelegateFullForm from '../pages/meeting-delegate/forms/full.json';
import meetingDelegateContextForm from '../pages/meeting-delegate/forms/context.json';
import meetingDelegateMiniForm from '../pages/meeting-delegate/forms/mini.json';
import meetingDelegateLookupForm from '../pages/meeting-delegate/forms/lookup.json';
import meetingDelegateTableView from '../pages/meeting-delegate/views/table.json';
import meetingDelegateCardsView from '../pages/meeting-delegate/views/cards.json';
import meetingDelegateDashboardView from '../pages/meeting-delegate/views/dashboard.json';

/** Тип запису «Делегат» зі сторінками пакета: меню, форми та подання з pages/meeting-delegate/. */
export const meetingDelegateDefinition: IRecordTypeDefinition = {
  ...meetingDelegateEntity,
  views: assembleViewSet({
      table: meetingDelegateTableView,
      cards: meetingDelegateCardsView,
      dashboard: meetingDelegateDashboardView,
  }),
  form: meetingDelegateFullForm,
  forms: { full: meetingDelegateFullForm, context: meetingDelegateContextForm, mini: meetingDelegateMiniForm, lookup: meetingDelegateLookupForm },
  menu: meetingDelegateMenu,
} as IRecordTypeDefinition;
